export default __webpack_public_path__ + "static/media/SFCompactDisplay-Regular.4d5ded7a.otf";